import { NgModule } from '@angular/core';

// modules (angular)
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

// modules

// components
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SharedModule } from '@app/shared/shared.module';
import { BlockHeaderComponent } from './components/block-header/block-header.component';
import { BlockProductsCarouselComponent } from './block-products-carousel.component';



@NgModule({
    imports: [
    // modules (angular)
    CommonModule,
    RouterModule,
    // modules (third-party)
    CarouselModule,
    // modules
    SharedModule,
    BlockProductsCarouselComponent, BlockHeaderComponent,
],
    exports: [BlockProductsCarouselComponent, BlockHeaderComponent,]
})
export class BlockProductCarouselModule { }
